import React, {Fragment, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {s_char_disciplines} from "../../_signals/s_char";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import {DisziplinesAvailable} from "./DisziplinesAvailable";
import {v4} from "uuid";
import {useSignals} from "@preact/signals-react/runtime";
import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import apiAddress from "../../_sig_api/_apiadress";
import createOptions from "../../_helper/createOptions";
import {s_app_cid} from "../../_signals/s_app";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

function DisziplinesAdd({open, isOpen}: IProp) {
    useSignals()

    const [name, setName] = useState('')

    const addDiszipline = () => {
        let disciplines = s_char_disciplines.value;

        const add: ICharDiscipline = {id: v4(), cid: s_app_cid.value, name: name, circle: 0, num: (disciplines.length + 1)}
        disciplines.unshift(add);

        s_char_disciplines.value = disciplines;

        fetch(apiAddress + "/char/disciplines/", createOptions('POST', add))
            .then((res) => res.json())
            .then((data) => {
                    if (!data.hasOwnProperty('result')) {
                        console.log('getSCharsData talents add failed', data);
                    }
                }
            )
        isOpen(false)
    }

    return <Fragment>
        <Dialog open={open}>
            <DialogContent>
                {s_char_disciplines.value.length === 0 ? 'Erste ' : null}
                {s_char_disciplines.value.length === 1 ? 'Zweite ' : null}
                {s_char_disciplines.value.length === 2 ? 'Dritte ' : null}
                Disziplin erlernen:
                <FormControl variant="standard"
                             size="small"
                             style={{width: '100%'}}>
                    <Select key={v4()}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                    >
                        {DisziplinesAvailable.map(disziplin => {
                            const index = s_char_disciplines.value.map(function (e) {
                                return e.name;
                            }).indexOf(disziplin);
                            if (index < 0) return <MenuItem key={v4()} value={disziplin}>{disziplin}</MenuItem>
                            else return null;
                        })
                        }
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => addDiszipline()}><CheckIcon/></Button>
                <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default DisziplinesAdd